import { useEffect } from "react";

/** Sets the document title and meta description for the current page. */
export const usePageMeta = (title: string, description?: string): void => {
  useEffect(() => {
    document.title = title;

    if (!description) return;
    const tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (tag) tag.content = description;
  }, [title, description]);
};
